import {
  CONTRACT_SVA_HOME_TABS_ID,
  CONTRACTS_TABS_ID,
} from '@/modules/contract/entities/enums/contract';
import { Contract } from '@/modules/contract/entities/interfaces/contract';

export const TRANSLATED_CONTRACT_STATUS = {
  expired: 'Expirado',
  active: 'Ativo',
  cancelled: 'Cancelado',
};

export const CONTRACT_SVA_HOME_TABS = [
  {
    id: CONTRACT_SVA_HOME_TABS_ID.CONTRACT,
    label: 'Contratos',
    icon: 'file-text-outline',
    active: false,
  },
  {
    id: CONTRACT_SVA_HOME_TABS_ID.SVA,
    label: 'Serviços Adicionais',
    icon: 'pricetags-outline',
    active: false,
  },
];

export const CONTRACTS_TABS = [
  {
    id: CONTRACTS_TABS_ID.ACTIVE,
    label: 'Ativo',
    icon: 'checkmark-square-2-outline',
    active: true,
  },
  {
    id: CONTRACTS_TABS_ID.CANCELLED,
    label: 'Cancelado',
    icon: 'slash-outline',
    active: false,
  },
  {
    id: CONTRACTS_TABS_ID.EXPIRED,
    label: 'Expirado',
    icon: 'alert-triangle-outline',
    active: false,
  },
  {
    id: CONTRACTS_TABS_ID.ALL,
    label: 'Todos',
    icon: 'file-text-outline',
    active: false,
  },
];

export const contractInitialState: Contract = {
  code: '',
  companyId: '',
  status: 'active',
  type: '',
  model: {
    id: 1,
    name: 'Adesão',
  },
  rules: [],
};
